import { TickersV2Service } from '@/services/tickers-v2-service'
import type {
  TickerResponse,
  TickersResponse,
  TickersFilter,
  TickersSortingKey,
} from '@/services/tickers-v2-service/types'
import { createAlertsBase } from './factories/alertsFactory'
import { defineStore } from 'pinia'

export const useTickersStore = defineStore('tickers-store', () => {
  const alertsBase = createAlertsBase<
    TickerResponse,
    TickersResponse,
    TickersFilter,
    TickersSortingKey
  >({ sortBy: 'change' }, TickersV2Service.fetchTickers)

  const sort = (sortByValue: string, sortOrderValue: number) => {
    alertsBase.sortBy.value = sortByValue as TickersSortingKey
    alertsBase.sortOrder.value = sortOrderValue
  }

  alertsBase.sortBy.value = 'total_24h'

  return {
    ...alertsBase,
    sort,
  }
})
